<app-modal-header title="Editors Configuration" [close]="close"></app-modal-header>

<div class="app-content editors-config-content">
  @if (changes) {
    <button
      type="button"
      class="editors-config-save-fab"
      aria-label="Save editors configuration"
      [disabled]="isSaving"
      (click)="save()">
      <app-display-icon
        [border]="false"
        [colour]="iconColourEnum.yellow"
        [icon]="icons.contentSaveOutline">
      </app-display-icon>
    </button>
  }

  <div id="content">
    <div class="section">
      <div class="heading" (click)="showSection('stockEditors')">
        Stock Editors
      </div>

      <div class="content" [hidden]="!show.stockEditors">
        @if (hasAccess('priceBanding')) {
          <div class="heading" (click)="showSection('stockEditors.priceBranding')">
            Price Banding
          </div>
          <div class="content price-banding" [hidden]="!show['stockEditors.priceBranding']">
            <app-price-banding [stores]="stores" [setChanges]="setChanges"></app-price-banding>
          </div>
        } @else {
          <div class="heading no-access">
            Price Banding
            <i>you do not have access to these settings</i>
          </div>
        }
      </div>

      <div class="content" [hidden]="!show.stockEditors">
        @if (hasAccess('priceBanding')) {
          <div class="heading" (click)="showSection('stockEditors.priceThreshold')">
            Price Thresholds
          </div>
          <div class="content" [hidden]="!show['stockEditors.priceThreshold']">
            <app-price-threshold [stores]="stores"></app-price-threshold>
          </div>
        } @else {
          <div class="heading no-access">
            Price Thresholds
            <i>you do not have access to these settings</i>
          </div>
        }
      </div>
    </div>
  </div>
</div>
